if (!customElements.get('eq-j-prev')) {
  class eqactionJPrev extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.handleChange.bind(this);
      this.handleMutations = this.handleMutations.bind(this);
      this.handleAccordion = this.handleAccordion.bind(this);

      this.observer = null;
    }

    async connectedCallback() {
      this.prodInfo = this.closest('product-info');
      if (!this.prodInfo) return;
      console.log('connected *****************');
      

      this.json = await this.readJSON();
      // console.log(this.json);

      this.listenColorChange();
      
      this.varIdScriptJSON = JSON.parse(
        this.querySelector('#eqactionJewelsVidScript')?.textContent ?? '{}'
      );
      
      this.refreshReferences();
      this.prodInfo.addEventListener('change', this.handleChange);
      this.observer = new MutationObserver(this.handleMutations);

      this.observer.observe(this.prodInfo, {
        childList: true,
        subtree: true
      });

      this.updateInputContent();
      this.createPreview();
      this.updateVariantAtLoad();
    }



    disconnectedCallback() {
      this.prodInfo?.removeEventListener('change',this.handleChange);
      this.accordionButton?.removeEventListener('click',this.handleAccordion);

      this.observer?.disconnect();
      this.observer = null;
    }

    handleAccordion() {
      if (!this.accordionInner) return;

      const isOpen = this.accordionInner.classList.contains('is-open');
      const newIsOpen = !isOpen;
      this.accordionInner.classList.toggle( 'is-open',!isOpen);
      this.accordionButton?.setAttribute('aria-expanded', String(!isOpen));

      

      // bisogna individuare variante;
      localStorage.setItem(`nwt-eqc-accordion-is-open-${this.dataset.id}`, !isOpen);
      // this.updateSelectedVariants(!isOpen);

      this.saveAccordionState(newIsOpen);
      const inpt = this.main.querySelector(`.eqc-prev-input[data-engraving="${!isOpen}"]`);
      // console.log('inpt !isOpen',!isOpen);

      this.bindCtaMessage();
      
      const engrInpts = this.main.querySelectorAll(`.eqc-prev-input[data-engraving]`);
      // console.log(engrInpts);
      
      // [...engrInpts].forEach(inpt => {
      //   ['change'].forEach(evt => 
      //     inpt.addEventListener(evt, (e) => console.log(`EVENTO NATIVO: ${evt} - `,e.target))
      //   );
      // });
      inpt.click();
    }

    saveAccordionState(isOpen) { localStorage.setItem( `nwt-eqc-accordion-is-open-${this.dataset.id}`, String(isOpen) ); }
    loadAccordionState() { return localStorage.getItem( `nwt-eqc-accordion-is-open-${this.dataset.id}` ) === 'true'; }

    restoreAccordionState() { 
      if (!this.accordionInner) return; 
      const isOpen = this.loadAccordionState(); 


      this.accordionInner.classList.toggle( 'is-open', isOpen ); 
      this.accordionButton?.setAttribute( 'aria-expanded', String(isOpen) ); 
      this.bindCtaMessage();
    }

    updateVariantAtLoad() {
      const isOpen = this.loadAccordionState(); 


      const engrInputs = this.main.querySelectorAll('input[data-engraving]');

      if(isOpen) {
        const engrInpt = [...engrInputs].find(inpt => inpt.getAttribute('data-engraving') === 'true')
        if(!engrInpt.checked) {
          console.log('not checked, so need to click, isOpen= ',isOpen);
          engrInpt.click();
        }
      } else {
        const notEngrInpt = [...engrInputs].find(inpt => inpt.getAttribute('data-engraving') === 'false');
        if(!notEngrInpt.checked) {
          console.log('not checked, so need to click, isOpen= ',isOpen);
          notEngrInpt.click();
        }
     
      }
    }

    bindCtaMessage() {
      const isOpen = this.accordionInner.classList.contains('is-open');
      // console.log('isOpen', isOpen);
      
      if(!isOpen) {
        this.input.value = "";
        // this.accordionButton.querySelector('.eqc-btn-add')?.classList.remove('hidden');
        // this.accordionButton.querySelector('.eqc-btn-remove')?.classList.add('hidden');
        this.accordionButton.closest('.eqc-btn-wrap')?.querySelector('.eqc-btn-add')?.classList.remove('hidden');
        this.accordionButton.closest('.eqc-btn-wrap')?.querySelector('.eqc-btn-remove')?.classList.add('hidden');
      } else {
        // this.accordionButton.querySelector('.eqc-btn-add')?.classList.add('hidden');
        // this.accordionButton.querySelector('.eqc-btn-remove')?.classList.remove('hidden');
        this.accordionButton.closest('.eqc-btn-wrap')?.querySelector('.eqc-btn-add')?.classList.add('hidden');
        this.accordionButton.closest('.eqc-btn-wrap')?.querySelector('.eqc-btn-remove')?.classList.remove('hidden');
      }
    }

    updateSelectedVariants(isOpen) {
      // open o true o false;
      // console.log('-> isOpen   : ',isOpen);

      const selectedVariantData = this.varScript;

      const newVariantOption = {
        option1:"",
        option2:"",
        option3:"",
      }

      if(isOpen) {
        newVariantOption.option1 = selectedVariantData.option1;
        newVariantOption.option2 = this.varIdScriptJSON?.allVariants?.find(v => v.variant_meta === 'engraving_true').option2;
        newVariantOption.option3 = !selectedVariantData.option3 ? "" : selectedVariantData.option3;
      }

      const newVid = this.varIdScriptJSON?.allVariants?.find(
        v => v.option1 === newVariantOption.option1 && 
        v.option2 === newVariantOption.option2 &&
        v.option3 === newVariantOption.option3
      )?.variant_id

      // console.log(newVariantOption, newVid);

      this.updateVariant(newVariantOption,newVid);
      
    }

    updateVariant(newVariantOption,vid) {
      // serve costruire selectedOptionValues con gli id delle opzioni. Almeno la option1 e 2.
      // Si deve prendere dallo script json interno il positionId dall'oggento con option_variant corrispondente a quella ricavata ERRATO

      // BISOGNA ricostruire con i value delle opzioni, sapendo che nell'array delle varianti abbiamo i valori singoli di option1,2,3


      // si agisce individualmente per ogni option[i], si dà la priorità a prendere i valori dai dataset degli input con value uguale.

      // get selectedOptionValues() {
      //   return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      //     ({ dataset }) => dataset.optionValueId
      //   );
      // }

      // -> deve ciclare su ogni fieldset del varSelects e cercare quello con input:checked o option[selected] con value che sia uno di quelli del json.

      // -> oppure lo si può girare, nel senso che per essere sicuri per ogni option del json si controlla che ci sia un fieldset con input con lo stesso value.

      // se non c'è si prende, per quell'iterazione con indice i, il valore di newVariantOption["option{i}"]

      // ipFound = INTERACTION POINT FOUND

      const allOptions = this.varIdScriptJSON?.options;
      const selectedOptionValues = [];

      Object.values(allOptions).forEach((opt, index) => {
        const valuesToFind = opt.map(value => value.option_name);
        const ipFound = this.findSelecetedExistingOptionValues(newVariantOption, valuesToFind);
        selectedOptionValues.push(ipFound);
        // console.log(index);
      });

      console.log(selectedOptionValues);
      const fakeInput = document.createElement('input');
      fakeInput.id = 'nwt-eqc-fake-input';
      fakeInput.classList.add('visually-hidden');
      this.prodInfo.appendChild(fakeInput);

      const fakeEvent = {target:fakeInput}
      // publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      //   data: {
      //     event: fakeEvent,
      //     target: fakeInput,
      //     selectedOptionValues: selectedOptionValues,
      //   },
      // });
    }

    findSelecetedExistingOptionValues(newVariantOption,valuesToFind) {
      // console.log(valuesToFind, newVariantOption);
      
      const fieldsets  = this.varSelects.querySelectorAll('fieldset');
      for (const [index, f] of fieldsets.entries()) {
        const checkedIP = f.querySelector( 'select option[selected], fieldset input:checked');
        const found = Boolean(checkedIP && valuesToFind.includes(checkedIP.value));

        if (found) {
          // console.log('Trovato:', index, checkedIP.value, checkedIP);
          return checkedIP.dataset.optionValueId;
        } else {
          const optionValue = newVariantOption[`option${index + 1}`];
          const optionId = Object.values(this.varIdScriptJSON?.options ?? {})
          .flat()
          .find(opt => opt.option_name === optionValue)
          ?.option_id;
          
          // console.log('NON Trovato INIZIALMENTE ',optionValue, optionId, newVariantOption);
          return optionId;
        }
      }


      return;
    }

    handleChange(e) {
      if (!this.varSelects?.contains(e.target)) return;
    }

    listenColorChange() {
      document.addEventListener('color-change', (e) => {
        const swatch = e.detail.radio.closest('variant-selects');
        if (!swatch || !this.prodInfo?.contains(swatch)) {
          return;
        }

        const color = e.detail.radio?.dataset.colorLabel;

        if(!color) return;
        this.createPreview(color);
      });
    }

    handleMutations(mutations) {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList') continue;

        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          // console.log('*** mutation detected');
          
          if (node.matches('variant-selects')) {
            // node.addEventListener('change', (e) => {console.log('*********** change ',e)});
            this.refreshReferences(node);

            return;
          }

          const newVarSelects = node.querySelector?.('variant-selects');

          if (newVarSelects) {
            // newVarSelects.addEventListener('change', (e) => {console.log('*********** change ',e)});
            this.refreshReferences(newVarSelects);
            return;
          }
        }
      }
    }

    refreshReferences(varSelects = null) {
      this.varSelects = varSelects || this.prodInfo?.querySelector('variant-selects');

      if (!this.varSelects) return;

      const script = this.varSelects.querySelector('script[data-selected-variant');
      this.main = this.varSelects.querySelector('#eqc-content-main');
      if(!this.main) return;

      // console.log('***** node varSelects cambiato ',this.varSelects);
      
    //   const label = this.main.querySelectorAll('input[data-engraving="true"],  .eqc-prev-label');

    //  [...label].forEach((el) => {
    //     el.addEventListener('click', (e) => {
    //       console.log('target:', e.target);
    //       console.log('currentTarget:', e.currentTarget);
    //     });
    //   });


      // console.log('++++ var change');
      
      if (script) {
        try {
          this.varScript = JSON.parse(script.textContent);
        } catch (error) {
          console.error( 'Errore parsing variant JSON:', error);
          this.varScript = null;
        }

        // this.accordionButton = this.main.querySelector('.eqc-btn');
        this.accordionButton = this.main.querySelector('.eqc-btn-extender');
        this.input = this.querySelector('input.nwt-text-i');
        const counter = this.input
          ?.closest('.nwt-t-input')
          ?.querySelector('.nwt-char-count');

        this.testoInserito = this.loadTextFromLocal();
        this.input.value = this.testoInserito;

        if (counter) counter.textContent = `${this.input.value.length}/60`;
        this.preview = this.querySelector('#eqc_prev');
        this.accordionInner = this.querySelector('.eqc-prev-inner');

        this.restoreAccordionState();

        this.accordionButton?.addEventListener('click', this.handleAccordion);
        this.bindCtaMessage();

      }

      // console.log('new varSel node:',this.varSelects);
    }

    updateInputContent() {
      this.input.addEventListener('input', (e) => {
        this.testoInserito = e.target.value;
        this.saveTextToLocal(e.target.value);
        this.createPreview();

        const counter = e.target
          .closest('.nwt-t-input')
          ?.querySelector('.nwt-char-count');

        if (counter) counter.textContent = `${e.target.value.length}/60`;
      });
    }

    saveTextToLocal(text) {
      localStorage.setItem(`nwt-eqc-text-${this.dataset.id}`, text);
    }

    loadTextFromLocal() {
      const text = localStorage.getItem(`nwt-eqc-text-${this.dataset.id}`) || "";
      return text;
    }


    async readJSON() {
      const link = this.dataset.json;

      try {
        const response = await fetch(link);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const json = await response.json();

        return json;
      } catch (error) {
        console.error("Errore nel caricamento del JSON:", error);
        return null;
      }
    }


    createPreview(color) {
      const currentColorLabel = !color ?
        this.varSelects
          ?.querySelector('input[data-color-label]:checked')
          ?.dataset.colorLabel

        :
          color;

      // console.log('color:', currentColorLabel);

      let img = this.preview.querySelector('.nwt-eqc-prev-img');
      
      if(!img) {
        img = document.createElement('img');
        img.setAttribute('loading', 'lazy');
        img.classList.add('nwt-eqc-prev-img', 'w-100');
        this.preview.appendChild(img);
      }

      img.src = this.json?.colors?.[currentColorLabel]?.preview ?? '';


      img.addEventListener('load', () => {
        // console.log(
        //   'IMG CARICATA:',
        //   imgNode.naturalWidth,
        //   imgNode.naturalHeight
        // );

        this.canvas = this.querySelector('#eqc_prev_canvas');

        if (!this.canvas) {
          console.error('Canvas #eqc_prev_canvas non trovato');
          return;
        }

        // Impostiamo le dimensioni DOPO il caricamento
        this.canvas.width = img.naturalWidth;
        this.canvas.height = img.naturalHeight;

        const ctx = this.canvas.getContext('2d');

        if (!ctx) {
          console.error('Impossibile ottenere il context 2D');
          return;
        }

        // DA QUI IN POI fai tutto il rendering
        this.renderPreview(ctx, currentColorLabel);
      }, { once: true });

      
    }


    async renderPreview(ctx, currentColorLabel) {
      const curveData = this.json?.colors?.[currentColorLabel];

      const data = {
        textOriginRelativeToImg: curveData?.textOriginRelativeToImg,
        pointsBeforeOrigin: curveData?.pointsBeforeOrigin,
        pointsAfterOrigin: curveData?.pointsAfterOrigin
      };


      // ----------------------------------------------------
      // CONFIG
      // ----------------------------------------------------
      
      
      const text = `${this.testoInserito}`;
      const font = "500 24px 'nwt-eqc-prev-font";
      const textColor = curveData["text-color"];;
      // const textColor = "#b78846";

      // ----------------------------------------------------
      // CONVERSIONE 0-100 -> PIXEL
      // ----------------------------------------------------

      const toPixel = (point) => {
        // console.log(this.canvas);
        return {
          x: point.x / 100 * this.canvas.width,
          y: point.y / 100 * this.canvas.height
        };
      }


      // ----------------------------------------------------
      // CATMULL-ROM
      // La curva passa attraverso i punti
      // ----------------------------------------------------

      function catmullRom(p0, p1, p2, p3, t) {

        const t2 = t * t;
        const t3 = t2 * t;

        return {
          x:
            0.5 * (
              (2 * p1.x) +
              (-p0.x + p2.x) * t +
              (2*p0.x - 5*p1.x + 4*p2.x - p3.x) * t2 +
              (-p0.x + 3*p1.x - 3*p2.x + p3.x) * t3
            ),

          y:
            0.5 * (
              (2 * p1.y) +
              (-p0.y + p2.y) * t +
              (2*p0.y - 5*p1.y + 4*p2.y - p3.y) * t2 +
              (-p0.y + 3*p1.y - 3*p2.y + p3.y) * t3
            )
        };
      }


      // ----------------------------------------------------
      // GENERA MOLTI PUNTI SULLA CURVA
      // ----------------------------------------------------

      function createCurve(points, samplesPerSegment = 100) {

        const result = [];

        for (let i = 0; i < points.length - 1; i++) {

          const p0 = points[i - 1] || points[i];
          const p1 = points[i];
          const p2 = points[i + 1];
          const p3 = points[i + 2] || p2;

          for (let j = 0; j < samplesPerSegment; j++) {

            const t = j / samplesPerSegment;

            result.push(
              catmullRom(p0, p1, p2, p3, t)
            );
          }
        }

        result.push(points[points.length - 1]);

        return result;
      }


      // ----------------------------------------------------
      // CALCOLA DISTANZE CUMULATIVE
      // ----------------------------------------------------

      function calculateDistances(points) {

        let distance = 0;

        const result = [
          {
            ...points[0],
            distance: 0
          }
        ];

        for (let i = 1; i < points.length; i++) {

          const dx = points[i].x - points[i - 1].x;
          const dy = points[i].y - points[i - 1].y;

          distance += Math.sqrt(dx * dx + dy * dy);

          result.push({
            ...points[i],
            distance
          });
        }

        return result;
      }


      // ----------------------------------------------------
      // TROVA UN PUNTO A UNA CERTA DISTANZA
      // ----------------------------------------------------

      function pointAtDistance(curve, distance) {

        if (distance <= 0)
          return curve[0];

        if (distance >= curve[curve.length - 1].distance)
          return curve[curve.length - 1];

        for (let i = 1; i < curve.length; i++) {

          if (curve[i].distance >= distance) {

            const a = curve[i - 1];
            const b = curve[i];

            const segmentLength = b.distance - a.distance;

            const t =
              (distance - a.distance) /
              segmentLength;

            return {
              x: a.x + (b.x - a.x) * t,
              y: a.y + (b.y - a.y) * t
            };
          }
        }
      }


      // ----------------------------------------------------
      // TANGENTE DELLA CURVA
      // ----------------------------------------------------

      function tangentAtDistance(curve, distance) {

        const delta = 1;

        const p1 = pointAtDistance(
          curve,
          Math.max(0, distance - delta)
        );

        const p2 = pointAtDistance(
          curve,
          Math.min(
            curve[curve.length - 1].distance,
            distance + delta
          )
        );

        return Math.atan2(
          p2.y - p1.y,
          p2.x - p1.x
        );
      }


      // ----------------------------------------------------
      // CREA CURVA
      // ----------------------------------------------------

      const rawPoints = [

        ...data.pointsBeforeOrigin.map(toPixel),

        toPixel({
          x: data.textOriginRelativeToImg.fromLeft,
          y: data.textOriginRelativeToImg.fromTop
        }),

        ...data.pointsAfterOrigin.map(toPixel)

      ];

      const curve = calculateDistances(
        createCurve(rawPoints, 100)
      );


      // ----------------------------------------------------
      // TROVA DISTANZA DELL'ORIGINE
      // ----------------------------------------------------

      const originPoint = toPixel({
        x: data.textOriginRelativeToImg.fromLeft,
        y: data.textOriginRelativeToImg.fromTop
      });


      // Troviamo il sample della curva più vicino all'origine.

      let originIndex = 0;
      let minDistance = Infinity;

      curve.forEach((p, i) => {

        const dx = p.x - originPoint.x;
        const dy = p.y - originPoint.y;

        const d = Math.sqrt(dx * dx + dy * dy);

        if (d < minDistance) {
          minDistance = d;
          originIndex = i;
        }

      });

      const originDistance =
        curve[originIndex].distance;


      // ----------------------------------------------------
      // DISEGNA CURVA
      // ----------------------------------------------------

      function drawCurve() {

        ctx.save();

        ctx.beginPath();

        curve.forEach((p, i) => {

          if (i === 0)
            ctx.moveTo(p.x, p.y);
          else
            ctx.lineTo(p.x, p.y);

        });

        ctx.strokeStyle = "#00000000";
        ctx.lineWidth = 1;
        ctx.stroke();

        ctx.restore();
        // console.log(ctx);
        
      }


      // ----------------------------------------------------
      // DISEGNA ORIGINE
      // ----------------------------------------------------

      function drawOrigin() {

        ctx.save();

        ctx.beginPath();

        ctx.arc(
          originPoint.x,
          originPoint.y,
          6,
          0,
          Math.PI * 2
        );

        ctx.fillStyle = "red";
        ctx.fill();

        ctx.fillStyle = "red";
        ctx.font = "14px Arial";

        ctx.fillText(
          "ORIGIN",
          originPoint.x + 10,
          originPoint.y
        );

        ctx.restore();
      }


      // ----------------------------------------------------
      // DISEGNA TESTO SULLA CURVA
      // ----------------------------------------------------

      async function drawTextAlongCurve() {

        ctx.save();

        await document.fonts.load("500 18px 'nwt-eqc-prev-font'");
        ctx.font = font;
        ctx.fillStyle = textColor;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        // -----------------------------------------------
        // Misuriamo ogni carattere
        // -----------------------------------------------

        const chars = [...text];

        const widths = chars.map(char =>
          ctx.measureText(char).width
        );

        const totalTextWidth = widths.reduce((sum, width) => sum + width, 0);


        // -----------------------------------------------
        // IL TESTO DEVE ESSERE CENTRATO SULL'ORIGINE
        // -----------------------------------------------

        let distance =
          originDistance - totalTextWidth / 2;


        // -----------------------------------------------
        // Disegniamo carattere per carattere
        // -----------------------------------------------

        chars.forEach((char, i) => {

          const charWidth = widths[i];

          // Centro del carattere
          const charDistance =
            distance + charWidth / 2;

          const point =
            pointAtDistance(
              curve,
              charDistance
            );

          const angle =
            tangentAtDistance(
              curve,
              charDistance
            );


          ctx.save();

          ctx.translate(
            point.x,
            point.y
          );

          ctx.rotate(angle);

          ctx.fillText(
            char,
            0,
            0
          );

          ctx.restore();


          distance += charWidth;
        });

        ctx.restore();
      }


      // ----------------------------------------------------
      // RENDER
      // ----------------------------------------------------

      drawCurve();
      // drawOrigin();
      await drawTextAlongCurve();
    }

    updateCanvasDimension(img) {
      if (!img) return;
      this.canvas = this.querySelector('#eqc_prev_canvas');
      const setCanvasSize = () => {
        this.canvas.width = img.naturalWidth;
        this.canvas.height = img.naturalHeight;

        // console.log(img.naturalWidth, img.naturalHeight);
      };

      if (img.complete && img.naturalWidth > 0) {
        setCanvasSize();
      } else {
        img.addEventListener('load', setCanvasSize, { once: true });
      }
    }

  }

  customElements.define('eq-j-prev',eqactionJPrev);
}
